<template>
  <v-dialog v-model="show" max-width="400px" persistent>
    <v-card>
      <v-card-title>
        <h3>{{ this.$t('analysis.alert.config.title') }}</h3>
      </v-card-title>
      <progress-linear :active="loading" dialog></progress-linear>
      <v-form ref="form">
        <v-row class="mx-3 mt-3">
          <v-col cols="12">
            <v-card flat class="dialog-form">
              <div class="d-flex flex-column">
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.description') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    {{ config.message }}
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.system') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    {{ config.systemId }}
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.level.warning') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="config.warningValue" type="number" :suffix="unitSymbol" class="w-auto" outlined hide-details dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.level.critical') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="config.criticalValue" type="number" :suffix="unitSymbol" class="w-auto" outlined hide-details dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.collectCount') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="config.collectCount" type="number" class="w-auto" outlined hide-details dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.isActive') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-checkbox v-model="config.active" dense hide-details></v-checkbox>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.isInrow') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-checkbox v-model="config.continuousAlert" dense hide-details></v-checkbox>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('analysis.alert.isFailback') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-checkbox v-model="config.failback" dense hide-details></v-checkbox>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save" small>{{ this.$t('common.save') }}</v-btn>
        <v-btn @click="close" small>{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from '../../../api/common/instances';

export default {
  props: {
    value: Boolean,
    alert: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      config: {},
      loading: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    unitSymbol() {
      return this.config.unitSymbol !== '#' ? this.config.unitSymbol : '';
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.fetchConfig();
      } else {
        this.config = {};
      }
    },
  },
  methods: {
    async fetchConfig() {
      this.startLoading();
      const { data } = await api.get(`/alert-configs/${this.alert.systemId}/${this.alert.sapDataCode}/${this.alert.code}`);
      this.config = data;
      this.finishLoading();
    },
    async save() {
      this.startLoading();
      await api.put(`/alert-configs/${this.config.systemId}/${this.config.sapDataCode}/${this.config.alertCode}`, this.config);
      this.finishLoading();
      this.$snackbar(this.$t('common.saved'));
      this.close();
    },
    startLoading() {
      this.loading = true;
    },
    finishLoading() {
      this.loading = false;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
  margin: 0px;
  padding: 0;
}
</style>
